import { defineModel } from "../define-model";

export type PostStatus =
	| "draft"
	| "pending_approval"
	| "scheduled"
	| "publishing"
	| "published"
	| "partial"
	| "failed"
	| "cancelled";

export type ScheduledPost = {
	id: string;
	workspaceId: string;
	projectId: string;
	calendarId: string;
	status: PostStatus;
	caption: string;
	firstComment: string | null;
	scheduledAt: string | null;
	timezone: string;
	publishedAt: string | null;
	source: "manual" | "flow" | "assistant" | "agent" | "content_plan" | "imported";
	flowId: string | null;
	flowRunId: string | null;
	nodeId: string | null;
	contentPlanItemId: string | null;
	zernioPostId: string | null;
	idempotencyKey: string;
	error: string | null;
	createdById: string | null;
	createdAt: string;
	updatedAt: string;
};

declare module "../types" {
	interface SyncModels {
		scheduledPost: ScheduledPost;
	}
}

export const model = defineModel({
	name: "scheduledPost",
	load: "lazy",
	indexes: ["projectId"],
	sort: (a, b) =>
		(a.scheduledAt ?? a.createdAt).localeCompare(b.scheduledAt ?? b.createdAt) ||
		a.createdAt.localeCompare(b.createdAt),
});
